import { config } from "../../config";
import { makeAnnouncements } from "../../entities/Announcement";
import { makeAreaObj } from "../../entities/Area";
import { Thunk } from "../actions/All";
import { ActionType } from "../ActionTypes";
import { DataState } from "../reducers/DataReducer";
import {
  fetchAnnouncements,
  fetchArchiveTerms,
  fetchArea,
} from "./RemoteActionCreators";

/**
 * Fetch all preset areas from the server and cache them.
 */
const getAllAreas: Thunk = async dispatch => {
  try {
    const raw = await dispatch(fetchArea);
    const area = raw.map(c => makeAreaObj(c));
    dispatch({ type: ActionType.SET_AREA, area });
  } catch {
    throw new Error("There was an error retrieving areas");
  }
};

/**
 * Fetch archive terms and conditions from the server and cache them.
 */
const getArchiveTerms: Thunk = async dispatch => {
  try {
    const terms = await dispatch(fetchArchiveTerms);
    dispatch({ type: ActionType.SET_ARCHIVE_TERMS, terms: terms.text });
  } catch {
    throw new Error("There was an error retrieving terms and conditions");
  }
};

/**
 * Fetch all announcements from the server and cache them.
 */
const getAllAnnouncements: Thunk = async dispatch => {
  try {
    const raw = await dispatch(fetchAnnouncements);
    const announcements = makeAnnouncements(raw);
    dispatch({ type: ActionType.SET_ANNOUNCEMENTS, announcements });
  } catch {
    throw new Error("There was an error retrieving announcements");
  }
};

const dataIsFresh = (state: DataState) =>
  state.loadedAt !== undefined && Date.now() - state.loadedAt < config.dataCacheTtlMs;

export const fetchData: Thunk = async (dispatch, getState) => {
  if (!dataIsFresh(getState().data)) {
    await Promise.all([
      dispatch(getAllAreas),
      dispatch(getArchiveTerms)
    ]);

    dispatch({ type: ActionType.DATA_LOADED, loadedAt: Date.now() });
  }

  dispatch(getAllAnnouncements);
};
